import { inject } from '@angular/core';
import { HttpRequest, HttpErrorResponse, HttpInterceptorFn, HttpHandlerFn } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { MessageLevel, PgMessagesService } from '../services/pg-messages.service';
import { throwError } from 'rxjs';

export const httpErrorMessagingInterceptor : HttpInterceptorFn = (req: HttpRequest<any>, next: HttpHandlerFn) => {
  const _messageService = inject(PgMessagesService);
  return next(req).pipe(
    catchError((error) => {
      if (error instanceof HttpErrorResponse) {
        if (!(error.error instanceof ErrorEvent)) {
          switch (error.status) {
          case 404: // notFound
            break;
          case 409: // Conflict
            break;
          case 410: // gone
            break;
          default:
            _messageService.publishMessage({
              message: `${error.message} With Code: ${error.status} => ${error.statusText}. Please inform Admin`,
              topic: 'Oops',
              level: MessageLevel.Oops
            });
            break;
          }
        }
      } else {
        console.error('some thing else happened');
      }
      return throwError(error);

    })
  );
};

